import React, { useEffect } from 'react';
import type { LoadableComponent } from '@loadable/component';

type PreloadProps<T> = {
  component?: LoadableComponent<T>;
  components?: LoadableComponent<any>[];
};

export function Preload<T>(props: React.PropsWithChildren<PreloadProps<T>>) {
  useEffect(() => {
    if (props.component) {
      props.component.preload();
    }
    if (props.components) {
      props.components.forEach(component => {
        component.preload();
      });
    }
  }, [props.component, props.components]);

  return null;
}
